import {
  mapApiItemsToCards,
  onlyCarouselItems,
} from "./contentCardMapper";
import { mapApiStories } from "./storyMapper";
import { asObject } from "../coerce";
import type {
  HomeApiResponse,
  HomeContentData,
  HomeContentSections,
} from "../../../@types/portalAluno";

const EMPTY_SECTIONS: HomeContentSections = {
  comunicados: [],
  cursos: [],
  destaques: [],
  segurancaNoTrabalhos: [],
  t1: [],
  trilhas: [],
};

export const mapHomeResponse = (value: unknown): HomeContentData => {
  const response = asObject<HomeApiResponse>(value) ?? {};

  return {
    stories: mapApiStories(response.storys),
    sections: {
      ...EMPTY_SECTIONS,
      comunicados: mapApiItemsToCards(response.comunicados, "comunicados"),
      cursos: mapApiItemsToCards(onlyCarouselItems(response.cursos), "cursos"),
      destaques: mapApiItemsToCards(response.destaques, "destaques"),
      segurancaNoTrabalhos: mapApiItemsToCards(
        onlyCarouselItems(response.segurancaNoTrabalhos),
        "seguranca-do-trabalho"
      ),
      t1: mapApiItemsToCards(response.t1, "treinamentos-de-1-ponto"),
      trilhas: mapApiItemsToCards(response.trilhas, "trilhas"),
    },
  };
};
